module.exports = __webpack_public_path__ + "media/vizilo_k.1a46d52e.mp3";